import React, { useState, useEffect } from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useNavigate } from "react-router-dom";

const images = [
  {
    src: "https://apulaitteet.fi:2053/videos/2.mp4" , // Video dosyası
    title: "Meidän avullamme olet jo antanut tuhansille tuotteille toisen mahdollisuuden.",
    buttonText: "Käytetyt Tuotteet",
    filter: "Sohvat",
    type: "video",
  },
  {
    src: `${process.env.PUBLIC_URL}/1d.jpg`,
    title: "",
    buttonText: "",
    filter: "",
    type: "image",
  },
  {
    src: `${process.env.PUBLIC_URL}/4d.png`,
    title: "Uudet Huonekalut",
    buttonText: "Osta Nyt",
    filter: "Uudet Huonekalut",
    type: "image",
  },
];

function Slider() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handlePrev = () =>
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );

  return (
    <Box sx={{ position: "relative", width: "100%", height: "40vh", overflow: "hidden" }}>
      {[images[0]].map((item, index) => {
        if (index !== currentIndex) return null;

        return item.type === "video" ? (
          <Box
            key={`video-slide-${index}`}
            sx={{
              position: "absolute",
              top: 0,
              width: "100%",
              height: "100%",
              overflow: "hidden",
              zIndex: 1,
            }}
          >
            <video
              autoPlay
              muted
              loop
              playsInline
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                position: "absolute",
                top: 0,
                left: 0,
              }}
              src={item.src}
            />
            {item.title && (
              <Box
                sx={{
                  position: "absolute",
                  top:'30%',
                  left: "50%",
                  transform: "translateX(-50%)",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  padding: 2,
                  borderRadius: 2,
                  textAlign: "center",
                  color: "white",
                  maxWidth: "100%",
                  zIndex: 2,
                }}
              >
                <Typography variant="body1" sx={{ mb: 2 }}>
                  {item.title}
                </Typography>
                {item.buttonText && (
                  <Button
                    onClick={() => {
                      localStorage.setItem("filter", item.filter);
                      navigate("/products");
                    }}
                    variant="contained"
                    sx={{
                      fontSize: 10,
                      backgroundColor: "white",
                      color: "black",
                      "&:hover": {
                        backgroundColor: "gray",
                        color: "white",
                      },
                    }}
                  >
                    {item.buttonText}
                  </Button>
                )}
              </Box>
            )}
          </Box>
        ) : (
          <Box
            key={`image-slide-${index}`}
            sx={{
              position: "absolute",
              top: 0,
              width: "100%",
              height: "100%",
              transition: "left 0.5s ease",
              backgroundImage: `url(${item.src})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {item.title && (
              <Box
                sx={{
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  padding: 2,
                  borderRadius: 2,
                  textAlign: "center",
                  color: "white",
                  maxWidth: "60%",
                }}
              >
                <Typography variant="body1" sx={{ mb: 2 }}>
                  {item.title}
                </Typography>
                {item.buttonText && (
                  <Button
                    onClick={() => {
                      localStorage.setItem("filter", item.filter);
                      navigate("/products");
                    }}
                    variant="contained"
                    sx={{
                      fontSize: 10,
                      backgroundColor: "white",
                      color: "black",
                      "&:hover": {
                        backgroundColor: "gray",
                        color: "white",
                      },
                    }}
                  >
                    {item.buttonText}
                  </Button>
                )}
              </Box>
            )}
          </Box>
        );
      })}

      {/* Sol Ok */}
      <IconButton
        onClick={handlePrev}
        sx={{
          position: "absolute",
          top: "50%",
          left: 16,
          transform: "translateY(-50%)",
          zIndex: 10,
          color: "white",
        }}
      >
        <ArrowBackIosIcon />
      </IconButton>

      {/* Sağ Ok */}
      <IconButton
        onClick={handleNext}
        sx={{
          position: "absolute",
          top: "50%",
          right: 16,
          transform: "translateY(-50%)",
          zIndex: 10,
          color: "white",
        }}
      >
        <ArrowForwardIosIcon />
      </IconButton>
    </Box>
  );
}

export default Slider;
